/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class SubStock extends React.Component {

	render() {
		return (
            <div>
				{this.props.children}
			</div>
		)
	}
}
;
export default SubStock;


// WEBPACK FOOTER //
// ./src/routes/subStock/index.js